import React from "react"
import { Button } from "antd"
import {
  GoogleOutlined,
  FacebookOutlined,
  AppleOutlined,
  GithubOutlined,
} from "@ant-design/icons"
import type { SocialLoginButtonProps } from "./SocialLoginButton.types"

const PROVIDER_ICONS: Record<string, React.ReactElement> = {
  Google: <GoogleOutlined />,
  Facebook: <FacebookOutlined />,
  Apple: <AppleOutlined />,
  GitHub: <GithubOutlined />,
}

const DEFAULT_TEXT: Record<string, string> = {
  Google: "Continue with Google",
  Facebook: "Continue with Facebook",
  Apple: "Continue with Apple",
  GitHub: "Continue with GitHub",
}

export const SocialLoginButton: React.FunctionComponent<
  SocialLoginButtonProps
> = ({ provider, text, onClick, className, ...buttonProps }) => {
  const icon = PROVIDER_ICONS[provider] || null
  const buttonText =
    text || DEFAULT_TEXT[provider] || `Continue with ${provider}`

  return (
    <Button
      type="default"
      size="large"
      icon={icon}
      onClick={onClick}
      className={`w-full flex items-center justify-center ${className || ""}`}
      {...buttonProps}
    >
      {buttonText}
    </Button>
  )
}
